export default {
  methods: {
    updateActivationCodes(code) {
      if (code.data) {
        this.activationCodes[code.id] = code.data;
      } else {
        delete this.activationCodes[code.id];
      }
    },
    activationCodeNotifications(results) {
      results.forEach(result => {
        this.$notify({
          group: 'notifications',
          // once activation code error messaging is sorted out api side
          // we can use result.message || 'Invalid Activation Code'
          text: result.status ? 'Successfully Activated' : ((result.errors || [])[0] || 'Invalid Activation Code'),
          type: result.status ? 'success' : 'error',
        });
      });
    },
  },
};
